module.exports = __webpack_public_path__ + "static/media/primary-2.f2145a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary-2.jpg
// module id = 151
// module chunks = 0